// src/lib/publicContent.js
import { useEffect, useState } from "react";
import contentDefault from "../contentDefault";

const PUBLIC_BASE = (process.env.REACT_APP_BASE_URL || "").replace(/\/+$/, "");

export function usePublicContent() {
  const [content, setContent] = useState(contentDefault);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await fetch(`${PUBLIC_BASE}/Content`, { headers: { Accept: "application/json" } });
        if (!res.ok) throw new Error("Failed");
        const json = await res.json();
        if (alive) setContent({ ...contentDefault, ...json });
      } catch {
        // fall back to contentDefault
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  return { content, loading };
}
